import React from "react";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import PaymentMethod from "../CheckoutProcess/Confirmation/PaymentMethod";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Sentry from "@sentry/react";
import instance from "../../store/actions/instance";
import { withRouter } from "react-router";
import ActionButton from "../ActionButton";
import Waiter from "./assets/waiter.png";
import TextField from "@material-ui/core/TextField";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

class Payment extends React.Component {
  state = {
    method: "none",
    paymentError: false,
    tapCardError: "",
    loading: false,
    waiterRequested: false,
    selectedTip: null,
    customTip: "",
  };

  componentDidMount = () => {
    this.loadTapCardComponent();
  };
  loadTapCardComponent = () => {
    if (!window.Tapjsli) return;
    const { language, settings } = this.props;
    if (!settings.tap_pk || !settings.enable_tap_v3_credit) return;
    var tap = window.Tapjsli(settings.tap_pk);
    window.tapObject = tap;
    var elements = tap.elements({});
    var style = {
      base: {
        color: "#535353",
        lineHeight: "18px",
        fontFamily: "sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "rgba(0, 0, 0, 0.26)",
          fontSize: "15px",
        },
      },
      invalid: {
        color: "red",
      },
    };
    // input labels/placeholders
    var labels = {
      cardNumber: "Card Number",
      expirationDate: "MM/YY",
      cvv: "CVV",
      cardHolder: "Card Holder Name",
    };
    //payment options
    var paymentOptions = {
      currencyCode: ["KWD", "USD", "SAR", "BHD", "OMR", "AED", "QAR"],
      labels: labels,
      TextDirection: "ltr",
    };
    //create element, pass style and payment options
    var card = elements.create("card", { style: style }, paymentOptions);
    window.tapCardObject = card;
    //mount element
    card.mount("#element-container");
    //card change event listener
    card.addEventListener("change", (event) => {
      if (event.status === "invalid") {
        this.setState({ tapCardError: "" });
      }
      if (event.BIN) {
      }
    });

    // // Handle form submission
    // var form = document.getElementById("form-container");
    // form.addEventListener("submit", (event) => {
    //   event.preventDefault();

    // });
  };
  handleChange = (value) => {
    if (this.state.method === value) {
      this.setState({
        method: "none",
      });
    } else {
      this.setState({ method: value, paymentError: false });
      if (value === "tap_v2_credit") {
        setTimeout(
          () =>
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: "smooth",
            }),
          200,
        );
      }
    }
  };

  pay = async () => {
    const { language, settings } = this.props;
    if (this.state.method == "none") {
      this.setState({ paymentError: true });
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
      return;
    }
    if (["cash", "kod"].includes(this.state.method)) {
      this.requestWaiter();
      return;
    }

    this.setState({ loading: true });
    let tapV3Token = null;
    try {
      if (
        this.state.method === "tap_v2_credit" &&
        window.tapObject &&
        settings.enable_tap_v3_credit
      ) {
        const tapRes = await window.tapObject.createToken(window.tapCardObject);
        if (tapRes.error) {
          this.setState({
            tapCardError: tapRes.error.message,
            loading: false,
          });

          return;
        } else {
          tapV3Token = tapRes.id;
        }
      }

      let on_demand_text = undefined;
      if (
        this.props.deliveryTime.type === "asap" &&
        settings.enable_on_demand_custom_string &&
        !this.props.deliveryTime.isPickup
      ) {
        on_demand_text =
          this.props.language === "arabic"
            ? settings.on_demand_custom_string_ar
            : settings.on_demand_custom_string;
      }
      if (
        this.props.deliveryTime.type === "asap" &&
        settings.enable_on_demand_custom_string_pickup &&
        this.props.deliveryTime.isPickup
      ) {
        on_demand_text =
          this.props.language === "arabic"
            ? settings.on_demand_pickup_custom_string_ar
            : settings.on_demand_pickup_custom_string;
      }
      const res = await instance.post(
        `/promise_place/`,
        {
          ...this.props.address,
          ...this.props.customerContact,
          ...this.props.cart,
          cart: [],
          promo_items: [],
          ...this.state,
          ...this.props.branch,
          ...this.props.promise,
          anchorEl: null,
          expected_delivery_date: this.props.deliveryTime.expected_date,
          expected_delivery_slot_start: this.props.deliveryTime.expected_start,
          expected_delivery_slot_end: this.props.deliveryTime.expected_end,
          is_asap: this.props.deliveryTime.type === "asap",
          on_demand_text: on_demand_text,

          isGift: this.props.promise.isGift || false,
          language: this.props.language,
          fbc_2: localStorage.getItem("fbc_2"),
          ttclid: localStorage.getItem("ttclid"),

          tapV3Token: tapV3Token,
          selected_country_code: this.props.currency.selected,
          no_cutlery: this.state.no_cutlery,
          ...this.state,
          dine_in_order_id: this.props.order.tracking_id,
          isPayment: true,
          tip:
            this.state.selectedTip === "Custom"
              ? parseFloat(this.state.customTip?.trim() || 0)
              : this.state.selectedTip,
        },
        {
          timeout: 30000,
        },
      );
      this.setState({ loading: false });

      if (res.data === "refresh") {
        window.location.reload(false);
        return;
      }
      if (res.data === "ResetDineIn") {
        this.props.modifyAddress({
          parkingNumber: "",
          token: null,
          dineInOrderID: null,
          dineInSessionID: null,
        });
        localStorage.removeItem("dine_in_order_id");
        localStorage.removeItem("dineInSessionID");
        this.props.history.replace("/");
        return;
      }
      if (res.data.paymentURL && res.data.paymentURL !== -1) {
        if (res.data.paymentURL != "Invalid") {
          //   this.props.saveLastOrder(res.data);
          window.location.href = res.data.paymentURL;
          return;
        } else {
          this.props.history.replace("/fail", {
            message:
              "The payment link could not be generated. Please contact us for help",
          });
          Sentry.captureException(
            new Error("Couldnt generate payment link"),
            (scope) => {
              scope.setExtra(
                "customer",
                JSON.stringify(this.props.customerContact),
              );
            },
          );
        }
      }
      if (res.data.message != "success" && !res.data.paymentURL) {
        this.props.history.replace("/fail", { message: res.data.message });
        Sentry.captureException(new Error(res.data.message), (scope) => {
          scope.setExtra(
            "customer",
            JSON.stringify(this.props.customerContact),
          );
        });
      }
    } catch (e) {
      console.log(e);
      this.props.history.replace("/fail", {
        message:
          language == "english"
            ? "Something wrong happened. Please try again, or contact us for help"
            : "حدث خطأ ما. الرجاء المحاولة مرة ثانية او تواصل معنا للمساعدة",
      });
      Sentry.captureException(e, (scope) => {
        scope.setExtra("customer", JSON.stringify(this.props.customerContact));
      });
    }
    this.setState({ loading: false });
  };

  renderPayButtonText = () => {
    const { order, settings, language } = this.props;
    const { selectedTip, customTip, waiterRequested } = this.state;
    if (waiterRequested) {
      return language === "arabic" ? "رجوع" : "Go Back";
    }
    let total = (order.total - order.additional_fee).toFixed(
      settings.currency_decimals,
    );
    const currency =
      language === "arabic"
        ? settings.currency_local
        : settings.currency_english;
    if (!settings.enable_additional_fee)
      return language === "arabic" ? "الدفع" : "Pay";
    if (selectedTip === "Custom" && !customTip)
      return language === "arabic"
        ? `الدفع (${total} ${currency})`
        : `Pay (${total} ${currency})`;
    let tip = 0;
    if (selectedTip === "Custom") tip = parseFloat(customTip || 0);
    else tip = selectedTip;
    total = (order.total - order.additional_fee + tip).toFixed(
      settings.currency_decimals,
    );
    return language === "arabic"
      ? `الدفع (${total} ${currency})`
      : `Pay (${total} ${currency})`;
  };

  requestWaiter = async () => {
    try {
      this.setState({ waiterRequested: true });

      const res = await instance.post("/customer_at_location/", {
        table_number: this.props.order.table_token,
        paymentMethod: this.state.method,
      });
    } catch (e) {
      this.setState({ waiterRequested: false });
      console.error(e);
    }
  };
  render() {
    const { language, order, settings } = this.props;
    const { loading, waiterRequested } = this.state;
    const currencyIcon = getCurrencyIcon(settings);

    const tipsValues = {
      EGP: [50, 100, 200, "Custom"],
      KWD: [0.25, 0.5, 1, "Custom"],
      BHD: [0.25, 0.5, 1, "Custom"],
      QAR: [2.5, 5, 10, "Custom"],
      AED: [2.5, 5, 10, "Custom"],
      OMR: [2.5, 5, 10, "Custom"],
      JOD: [1, 2, 3, "Custom"],
      SAR: [4, 8, 12, "Custom"],
    };
    return (
      <>
        {waiterRequested ? (
          <>
            {settings.enable_additional_fee && (
              <div style={{ height: 25 }}></div>
            )}
            <div
              className="border w-100 row m-0 mt-4"
              style={{
                backgroundColor: "white",
                minHeight: 65,
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: 20,
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <img
                  src={Waiter}
                  height={160}
                  width={160}
                  style={{
                    left: 12,
                    position: "relative",
                  }}
                />
                <p className="mt-3 mb-3 bold" style={{ fontSize: 22 }}>
                  {language == "english"
                    ? "A waiter is on the way!"
                    : "موظف الخدمة في الطريق!"}
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            {settings.enable_additional_fee && (
              <div>
                <div style={{ height: 25 }}></div>
                <div
                  className="border w-100 row m-0 mt-4"
                  style={{
                    backgroundColor: "white",
                    minHeight: 65,
                    alignItems: "center",
                    flexDirection: "column",
                    paddingBottom: 30,
                  }}
                >
                  <div style={{ marginTop: 30, width: "100%" }}>
                    <p
                      className="box-title"
                      style={{
                        textAlign: language === "arabic" ? "right" : "left",
                      }}
                    >
                      {language == "english" ? "Add a tip?" : "اضافة اكرامية؟"}
                    </p>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "auto auto auto auto",
                        columnGap: "10px",
                        padding: "0px 10px",
                        marginTop: 20,
                        height: 35,
                      }}
                    >
                      {(
                        tipsValues[settings?.currency_iso] || [
                          0.25,
                          0.5,
                          1,
                          "Custom",
                        ]
                      ).map((amount) => (
                        <div
                          style={{
                            border:
                              this.state.selectedTip === amount
                                ? ""
                                : "1px solid #999",
                            borderRadius: 4,
                            display: "grid",
                            alignContent: "center",
                            cursor: "pointer",
                            backgroundColor:
                              this.state.selectedTip === amount
                                ? this.props.themeColor
                                : "white",
                            color:
                              this.state.selectedTip === amount
                                ? "white"
                                : "black",
                          }}
                          onClick={() => {
                            if (this.state.selectedTip === amount)
                              this.setState({ selectedTip: null });
                            else this.setState({ selectedTip: amount });
                          }}
                        >
                          <div
                            className={
                              ["SAR", "AED"].includes(settings?.currency_iso) &&
                              amount !== "Custom"
                                ? currencyIcon
                                : ""
                            }
                          >
                            {amount !== "Custom"
                              ? amount.toFixed(settings.currency_decimals)
                              : language === "english"
                                ? amount
                                : "آخر"}{" "}
                            {amount !== "Custom" && (
                              <span>
                                {language === "arabic"
                                  ? settings.currency_local
                                  : settings.currency_english}
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    {this.state.selectedTip === "Custom" && (
                      <div style={{ padding: "0px 10px", marginTop: 20 }}>
                        <TextField
                          inputProps={{
                            className: "text-center",
                          }}
                          autoFocus
                          fullWidth
                          margin="dense"
                          type="number"
                          variant="outlined"
                          placeholder={
                            language === "english"
                              ? "Enter the amount"
                              : "ادخل المبلغ"
                          }
                          onChange={(e) => {
                            this.setState({
                              customTip: e.target.value.replace(/[^0-9.]/g, ""),
                            });
                          }}
                          defaultValue={undefined}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div
              className="border w-100 row m-0 mt-4"
              style={{
                backgroundColor: "white",
                minHeight: 65,
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <PaymentMethod
                handleChange={this.handleChange}
                value={this.state.method}
                paymentError={this.state.paymentError}
                setPaymentMethod={this.props.setPaymentMethod}
              />

              <div
                className="my-5"
                style={{
                  display:
                    this.state.method === "tap_v2_credit" ? "block" : "none",
                }}
              >
                <p
                  className="box-title"
                  style={{
                    textAlign: language === "arabic" ? "right" : "left",
                  }}
                >
                  {language === "arabic" ? "تفاصيل البطاقة" : "Card Details"}
                </p>
                {this.state.tapCardError && (
                  <p
                    style={{
                      color: "red",
                      textAlign: "left",
                      padding: "0px 10px",
                      fontWeight: "bold",
                    }}
                  >
                    * {this.state.tapCardError}
                  </p>
                )}
                <form id="form-container" method="post" action="/charge">
                  <div id="element-container"></div>
                </form>
              </div>
            </div>
          </>
        )}
        <ActionButton
          action={
            loading ? (
              <span>
                <CircularProgress
                  style={{ width: 30, height: 30, color: "white" }}
                />
              </span>
            ) : (
              this.renderPayButtonText()
            )
          }
          onClick={() =>
            waiterRequested
              ? this.setState({ waiterRequested: false })
              : this.pay()
          }
          color="#0099cc"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,

    // copied from confirmation
    language: state.store.language,
    cart_items: state.cart.cart,
    settings: state.store.store.settings,
    categories: state.store.store.categories,
    customerContact: state.customers?.customerContact,
    address: state.customers?.address,
    customers: state.customers,
    cart: state.cart,
    deliveryCharges: state.store.store.delivery_charges,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    applied_promo: state.cart.promos,
    promise: state.promise,
    areas: state.store.store.areas,
    branch: state.branch,
    discounts: state.cart.discounts,
    promo_items: state.cart.promo_items,
    smart_promos: state.store.store.smart_promos,
    cart_categories_min: state.cart.categories_min_order,
    store_categories_min: state.store.store.categories_minimum_order_value,
    applied_promos: state.cart.smart_promos,
    branches: state.store.store.branches,
    deliveryTime: state.deliveryTime,
    current_product: state.store.current_product,
    auth: state.auth,
    allow_only_pickup: state.cart.pickup_only_items > 0,
    allow_only_delivery: state.cart.delivery_only_items > 0,
    currency: state.currency,
    countries: state.store.store.all_countries || state.store.store.countries,
    baseCountryID: state.store.store.base_country_id,
    shipping: state.shipping,
    abandonedCartID: state.abandonedCart.id,
    themeColor: state.store.store.settings.dark || "#0099cc",
    paymentMethod: state.cart.payment_method,
    store: state.store.store,
    dhl_error: state.shipping.dhl_error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPaymentMethod: (method) =>
      dispatch({ type: "SET_PAYMENT_METHOD", payload: method }),

    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Payment));
